<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-8">
                <h4 class="m-b-0">Marketplace Members</h4>
                <p class="text-muted m-t-0">Click view to see information of members.</p>
            </div>
            <div class="col-4">

            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <b-col class="my-1" lg="6">
                            <b-form-group
                                    class="mb-4"
                                    label="Filter"
                                    label-align-sm="right"
                                    label-cols-sm="1"
                                    label-for="filter-input"
                                    label-size="sm">
                                <b-input-group size="sm">
                                    <select class="form-control" id="exampleFormControlSelect1" v-model="filter">
                                        <option :key="catalog_name" v-for="catalog_name in catalog_names">
                                            {{catalog_name}}
                                        </option>
                                    </select>
                                    <select class="form-control ml-2" id="did_records" v-if="did_record_keys.length>0"
                                            v-model="did_record_key">
                                        <option :key="catalog_name" v-for="catalog_name in did_record_keys">
                                            {{catalog_name}}
                                        </option>
                                    </select>
                                    <b-form-input class="ml-2"
                                                  id="filter-input"
                                                  placeholder="Type to Search"
                                                  type="search"
                                                  v-model="did_record_value">
                                    </b-form-input>
                                    <b-input-group-append>
                                        <b-button @click="reset()">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-table :busy="busy" :current-page="currentPage" :fields="fields" :filter="filter"
                                 :filter-included-fields="filterOn"
                                 :items="dids"
                                 :per-page="perPage"
                                 :sort-by="sortBy" :sort-desc="sortDesc" :sort-direction="sortDirection"
                                 @filtered="onFiltered"
                                 responsive striped tbody-tr-class="rowClass" v-if="dids.length>0">
                            <template #cell(short_name)="data">
                                <b>{{data.value}}</b>
                            </template>
                            <template #cell(created)="data">
                                {{ data.value | date }}
                            </template>
                            <template #cell(did)="data">
                                <a :href="$BORLAUG + '/identity/did:bws:' + data.value.toString().substring(2, data.value.length)"
                                   target="_blank">
                                    <img class="bws-ico" src="@/assets/images/orange_bws_logo.png"> Borlaug</a>
                            </template>
                            <template #cell(action)="data">
                                <i @click="viewDid(data.item)" class="text-dark-green font-18 fa fa-border fa-eye" data-placement="top"
                                   data-toggle="tooltip" style="cursor: pointer;"
                                   title="Print Smart Card"></i>
                                <i @click="printCard(data.item.catalog, data.item.did)" class="text-info font-18 fa fa-border fa-print" data-placement="top"
                                   data-toggle="tooltip" style="cursor: pointer;"
                                   title="Print Smart Card"></i>
                            </template>
                        </b-table>
                        <template v-else>
                            <h4 class="card-title text-muted text-center m-t-30">No records found.</h4>
                            <h5 class="card-title text-muted text-center m-b-30">Change search criteria and try again</h5>
                        </template>
                        <div class="card-footer" v-if="totalRows>5">
                            <div class="row">
                                <div class="col">
                                    <per-page v-model="perPage" :total="totalRows"/>
                                </div>
                                <div class="col-auto" v-if="totalRows>perPage">
                                    <b-pagination :per-page="perPage" :total-rows="totalRows" v-model="currentPage"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Blockie from "../../common/Blockie";
    import Paginate from 'vuejs-paginate';
    import PerPage from "@/components/protected/common/PerPage.vue";

    export default {
        name: "Members",
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        components: {Blockie, Paginate, PerPage},
        watch: {
            filter: async function (nv, ov) {
                if (nv) {
                    this.selected_catalog = this.catalogs.find(c => c.name.trim() === nv.trim()).catalog;
                    this.did_record_key = null;
                    this.did_record_value = null;
                    await Promise.all([
                        this.getDidTemplate(),
                        this.getDids()
                    ])
                }
            },
            did_record_key: function (nv, ov) {
                console.log(nv)
                if (nv) {
                    this.getDids();
                }
            },
            did_record_value: function (nv, ov) {
                if (nv) {
                    this.getDids();
                }
            }
        },
        data() {
            return {
                members: [],
                pageCount: 1,
                total: 0,
                member: {
                    id: null,
                    biz_name: null
                },
                catalogs: [],
                catalog_names: [],
                dids: [],
                fields: [
                    {
                        key: 'catalog_name',
                        label: 'Catalog',
                    },
                    {
                        key: 'short_name',
                        label: 'Name',
                        sortable: true
                    },
                    {
                        key: 'created',
                        label: 'Created on',
                        sortable: true
                    },
                    {
                        key: 'did',
                        label: 'View on Explorer',
                    },
                    {
                        key: 'action',
                        label: 'Action',
                    }
                ],
                busy: false,
                currentPage: 1,
                perPage: 5,
                totalRows: 0,
                sortBy: 'name',
                sortDesc: false,
                sortDirection: 'asc',
                filter: null,
                filterOn: ['catalog_name'],
                selected_catalog: null,
                did_record_keys: [],
                did_record_key: null,
                did_record_value: null
            };
        },
        mounted() {
            // this.getMembers(1);
            this.init();
        },
        methods: {
            async init() {
                try {
                    $(".preloader").fadeIn();
                    await this.getCatalogs();
                    await Promise.all([
                        this.getDids(),
                        this.getDidTemplate()
                    ])
                }catch (e) {

                }finally {
                    $(".preloader").fadeOut();
                }
            },
            async getCatalogs() {
                try {
                    let {data} = await this.$identity.get(`/identity/catalogs?page=0&per_page=1000`);
                    this.catalogs = data.catalogs.filter(c => c.catalog_type === 'Individual');
                    this.catalog_names = this.catalogs.map(cf => cf.name);
                    this.filter = this.$parent.selected_filter ? this.$parent.selected_filter : this.catalog_names.length > 0 ? this.catalog_names[0] : null;
                    this.selected_catalog = this.$parent.selected_catalog ? this.$parent.selected_catalog : this.catalogs.length > 0 ? this.catalogs[0].catalog : null;
                } catch (e) {

                }
            },
            async getDids() {
                try {
                    $(".preloader").fadeIn();
                    let {data} = await this.$identity.get(`/identity/controller/dids?page=0&per_page=2000`, {
                        params: {
                            attribute_name: this.did_record_key,
                            attribute_value: this.did_record_value
                        }
                    });
                    let self = this;
                    this.dids = data.dids.filter(did => (did.catalog && did.catalog === self.selected_catalog)).map(f_did=> ({
                        ...f_did,
                        catalog_name: self.filter
                    }));
                } catch (e) {
                    console.error(e)
                } finally {
                    $(".preloader").fadeOut();
                }
            },
            async getDidTemplate() {
                try {
                    let {data} = await this.$identity.get(`identity/catalogs/${this.selected_catalog}/active_did_template`);
                    this.did_record_keys = data.template_fields ? data.template_fields.map(f => f.name) : [];
                    this.did_record_key = this.did_record_keys.length > 0 ? this.did_record_keys[1] : null;
                } catch (e) {

                }
            },
            getMembers(page) {
                $(".preloader").fadeIn();
                this.$http
                    .get("/marketplaces/" + this.currentOrg.marketplace_id + "/members", {
                        params: {
                            page: page,
                            perPage: 10
                        }
                    })
                    .then(reply => {
                        $(".preloader").fadeOut();
                        this.total = reply.data.total;
                        this.members = reply.data.members;
                        //this.setPageCount();
                    })
                    .catch(err => {
                        $(".preloader").fadeOut();
                        console.log(err);
                    });
            },
            async getPurchase() {
                let purchase = await this.$http
                    .get("/marketplaces/" + this.currentOrg.marketplace_id + "/members/purchasesReport");
                console.log(purchase);
            },
            pageHandler(pageNum) {
                this.getMembers(pageNum);
            },
            setPageCount() {
                this.pageCount = this.total <= 10 ? 1 : Math.ceil(this.total / 10);
            },
            selectMember(member) {
                this.member = member;
            },
            async removeMember() {
                try {
                    await this.$http.delete(`marketplaces/${this.currentOrg.marketplace_id}/plans/${this.member.plan_id}/members`, {data: {org_id: this.member.id}});
                    this.$toastr('success', `${this.member.biz_name} successfully removed`, 'Member Removed');
                    await this.getMembers(1);
                } catch (e) {
                    this.$toastr('error', `Failed to remove ${this.member.biz_name}`, 'Failed');
                }
            },
            viewDid(member) {
                this.$parent.selected_catalog = this.selected_catalog;
                this.$parent.selected_filter = this.filter;
                this.$router.push({name: 'view-member', params: {catalogid: member.catalog, memberid: member.did}})
            },
            onFiltered(filteredItems) {
                // Trigger pagination to update the number of buttons/pages due to filtering
                this.totalRows = filteredItems.length
                this.currentPage = 1
            },
            reset() {
                this.did_record_value = null;
                this.did_record_key = null;
                this.getDids()
            },
            printCard(catalog, did) {
                this.$router.push({name: 'view-member-card', params: {catalogid: catalog, memberid: did}})
            }
        }
    }
</script>

<style scoped>

</style>
